import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DsButtonVariants, DsModule, DsBannerState } from '@levelaccess/design-system';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { BusMessageService } from '../../../../services/bus-message.service';
import { LoadErrorHandler } from '../../../../services/load-error-handler';
import { WorkspaceService } from '../../../../services/workspace.service';
import { CommonPipesModule } from '../../../../shared/common-pipes.module';
import { IRestoreWorkspaceResponse } from '../../../../../../shared/interfaces/workspace.interface';
import { errorMessagesNames } from '../../../../../../shared/constants/errors';

export enum WorkspaceStateAction {
  close = 'close',
  restore = 'restore',
  archive = 'archive',
}

@Component({
  selector: 'app-selfmanage-change-workspace-state-modal',
  templateUrl: './selfmanage-change-workspace-state-modal.component.html',
  imports: [DsModule, CommonPipesModule],
  providers: [BusMessageService],
  standalone: true,
})
export class SelfmanageChangeWorkspaceStateModalComponent implements OnInit {
  private subscriptions: Subscription;

  @Input() workspaceId: string;
  @Input() changeTo: WorkspaceStateAction;
  @Input() public restoreError: string;

  modalTitleAndActionName: string;

  constructor(
    private readonly modal: NgbActiveModal,
    private readonly workspaceService: WorkspaceService,
    private readonly loadErrorHandler: LoadErrorHandler,
  ) {
    this.subscriptions = new Subscription();
  }

  private onUpdateError(error: HttpErrorResponse): void {
    if (
      this.changeTo === WorkspaceStateAction.restore &&
      error.error?.app?.name === errorMessagesNames.ErrorWorkspaceRestoreNoSpaceForAssets
    ) {
      this.restoreError = 'error_workspace_restore_no_space_for_assets';
      return;
    }

    this.loadErrorHandler.handleError('workspace_update_error', error, SelfmanageChangeWorkspaceStateModalComponent.name, true);
  }

  public onChangeConfirmed(): void {
    this.restoreError = null;

    if (this.changeTo === WorkspaceStateAction.archive) {
      this.subscriptions.add(
        this.workspaceService.archiveWorkspace(this.workspaceId).subscribe({
          next: () => this.modal.close({ actionType: this.changeTo }),
          error: this.onUpdateError.bind(this),
        }),
      );
    }

    if (this.changeTo === WorkspaceStateAction.restore) {
      this.subscriptions.add(
        this.workspaceService.restoreWorkspace(this.workspaceId).subscribe({
          next: (response: IRestoreWorkspaceResponse) =>
            this.modal.close({ actionType: this.changeTo, restoreResponse: response }),
          error: this.onUpdateError.bind(this),
        }),
      );
    }
  }

  public onCancel(): void {
    this.modal.dismiss();
  }

  public ngOnInit(): void {
    this.modalTitleAndActionName =
      this.changeTo === WorkspaceStateAction.archive ? 'label_archive_workspace' : 'label_restore_workspace';
  }

  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  protected readonly WorkspaceStateAction: typeof WorkspaceStateAction = WorkspaceStateAction;
  protected readonly DsBannerState: typeof DsBannerState = DsBannerState;
}
